import React from 'react';
import OldUrls from '../../../models/utils/OldUrls';
import UILink from '../../../ui/UILink';
import Trainer from '../../../models/event/Trainer';
import {Licensee} from "../../../schema";
import {reverse} from "../../../urls";

type Props = {
  licensee: Licensee
  amount: string
  expiresAt: string
}

export default function ExpiringLicenseRecord({
                                                licensee,
                                                amount,
                                                expiresAt,
                                              }: Props) {

  return (
    <div className="grid grid-cols-8 pt-3 gap-y-1">
      <div className="col-span-4 text-base">
        <UILink href={reverse('licensee_profile', {id: licensee.id})}>{licensee.name}</UILink>
      </div>
      <div className="text-base col-span-2 pl-0.5 text-green">
        {amount}
      </div>
      <div className="col-span-2 text-base text-right">
        {expiresAt}
      </div>
    </div>
  );
}
